import formStepper from "./formStepper.component";

const formStepperModule = angular
  .module("app.components.formStepper", [])
  .component("formStepper", formStepper);

export default formStepperModule;



// WEBPACK FOOTER //
// ./src/components/formStepper/formStepper.module.js